import { useState, useContext, createContext } from 'react';
import authService from '../api/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(authService.getCurrentUser());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const login = async (pseudo, password, rememberMe = true) => {
        setLoading(true);
        setError(null);
        try {
            const userData = await authService.login(pseudo, password, rememberMe);
            const currentUser = authService.getCurrentUser();
            setUser(currentUser);
            return currentUser;
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur de connexion');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const register = async (pseudo, password) => {
        setLoading(true);
        setError(null);
        try {
            const userData = await authService.register(pseudo, password);
            const currentUser = authService.getCurrentUser();
            setUser(currentUser);
            return currentUser;
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur d\'inscription');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        authService.logout();
        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{ user, loading, error, login, register, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth doit être utilisé avec AuthProvider');
    }
    return context;
};